import { fireStore } from '../firebase';
import isEmpty from 'lodash/isEmpty';

export const getDocs = async ({ lastDoc, limit, filter }) => {
  let docRef = fireStore.collection('crisis');

  if (filter && !isEmpty(filter.created_by)) {
    if (Array.isArray(filter.created_by)) {
      docRef = docRef.where('created_by', 'in', filter.created_by);
    } else {
      docRef = docRef.where('created_by', '==', filter.created_by);
    }
  }

  if (filter && filter.brand) {
    docRef = docRef.where('brand', '==', filter.brand);
  }

  if (filter && filter.category) {
    docRef = docRef.where('category', '==', filter.category);
  }

  if (filter && filter.created_at && filter.created_at.length === 2) {
    docRef = docRef.where('created_at', '>=', filter.created_at[0].startOf('day').unix()).where('created_at', '<=', filter.created_at[1].endOf('day').unix());
  }

  if (filter && filter.price) {
    docRef = docRef.where('price', '==', filter.price * 1);
  }

  if (filter && filter.project) {
    docRef = docRef.where('project', '==', filter.project);
  }

  docRef = docRef.orderBy('created_at', 'desc').limit(limit);

  if (lastDoc) {
    docRef = docRef.startAfter(lastDoc);
  }

  return await docRef.get()
  .then((documentSnapshots) => {
    return documentSnapshots.docs;
  })
  .catch(error => { console.log(error); return error })
}

export const addDoc = async ({data}) => {
  return await fireStore.collection('crisis').add(data);
}
